import { addNavMenuItem } from '@vendure/admin-ui/core';

// Como o Vendure não suporta extensões no header/navbar global,
// mantemos o acesso via menu lateral.
// O componente EventsDropdownComponent pode ser reutilizado na página.
export default [
    addNavMenuItem(
        {
            id: 'system-events',
            label: 'Eventos',
            routerLink: ['/extensions/system-events'],
            icon: 'notification',
        },
        'settings'
    ),
];
